import { Injectable } from '@angular/core';
import { RegbpService } from '../api/src/app/services/regbp.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { KeyValue } from '@angular/common';
import { LegalForm } from '../api/src/app/models/REGBP-V1.0.0/legalform.model';

@Injectable({
  providedIn: 'root'
})
export class LegalFormFacade {
  constructor(public regbpService: RegbpService) {}
  getLegalForms(language: string): Observable<KeyValue<string, string>[]> {
    return this.regbpService.getLegalFormList(language).pipe(
      map((results: any) => results.$response.body.values),
      map((results: LegalForm[]) =>
        results
          .sort((a, b) => (a.value > b.value ? 1 : b.value > a.value ? -1 : 0))
          .map((LegalformObject: LegalForm) => {
            return {
              key: LegalformObject.code,
              value: LegalformObject.value
            };
          })
      )
    );
  }
}
